<svg class="icon-context max-width-init" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M1 1L7 7M7 1L1 7" stroke="currentColor"/>
</svg>
